import { baseGet } from "@/utils/api/base";
import apiEndPointList from "../constant/apiEndPointsList";


const languageService = {
    getAllLanguages: async (id_path?: string, options?: { includeHidden?: boolean }) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.language.GET_ALL_LANGUAGE(id_path),
            });
            
            // Intercept and filter languages for Viewer & DynamicLanguageForm
            if (response && response.data && response.data.success && Array.isArray(response.data.data)) {
                let isPreviewMode = false;
                let isAdmin = options?.includeHidden === true;
                if (typeof window !== 'undefined') {
                    const searchParams = new URLSearchParams(window.location.search);
                    const previewParam = searchParams.get('preview');
                    if (previewParam === 'true') {
                        sessionStorage.setItem('previewMode', 'true');
                        isPreviewMode = true;
                    } else if (previewParam === 'false') {
                        sessionStorage.removeItem('previewMode');
                        isPreviewMode = false;
                    } else {
                        isPreviewMode = sessionStorage.getItem('previewMode') === 'true';
                    }

                    if (window.location.pathname.includes('/admin')) {
                        isAdmin = true;
                    }
                }
                
                // Do not apply public viewer filter in admin or preview mode or when includeHidden is requested
                if (!isPreviewMode && !isAdmin) {
                    response.data.data = response.data.data.filter((lang: any) => {
                        const isPublic = lang.is_public === 1 || lang.is_public === '1' || lang.is_public === true || lang.is_public === undefined;
                        return isPublic;
                    });
                }
            }
        } catch (err) {
            response = err;
        }

        return response?.data;
    },
    getLanguageDefault: async (id_path?: string) => {
        let response: any = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.language.GET_LANGUAGE_DEFAULT(id_path),
            });
        } catch (err) {
            response = err;
        }

        return response?.data;
    },

}

export default languageService;